import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsIntalentCheckMixin extends Vue {
  get isIntalentModule() {
    return !!this.$store.getters.hasApiModuleIntalent;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isIntalentCheck.ts